module.exports = __webpack_public_path__ + "spa_static_mobile/img/banner.8d46efef.png";